import React from 'react';
import Day from './day';
import {  useIntl } from 'react-intl';
import withFormWrapper from '@Elements/Form/formWrapper';
import {
  ScheduleWrap,
  ScheduleHeader,
  HeaderLabel,
  DayRow,
  TimeGroup,
  TimeCell,
  TimeInput,
  RangeDash,
  OffLabel
} from './styles';
import { EventConfigForm } from '../types';

const DAYS = ["MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY"
]

interface ScheduleProps{
  from: boolean;
  to: boolean;
}

const Schedule = withFormWrapper<EventConfigForm, ScheduleProps>(({ from, to, formik: { values: { sensorId, eventConfig: { schedule } }, setFieldValue} }) => {

  const { formatMessage } = useIntl();

  React.useEffect(() => {
    if (schedule.length === 0) {

      const newSchedule = [];

      for(const day of DAYS){
        newSchedule.push({
          sensorId,
          active: true,
          fromTime: "00:00",
          toTime: "23:59",
          day
        })
      }

      setFieldValue("eventConfig.schedule", newSchedule);
    }
  }, [])

  const single = !(from && to);

  return (
    <ScheduleWrap>
      <ScheduleHeader>
        <span />
        <span />
        {from && <HeaderLabel>{formatMessage({id: "universalFrom", defaultMessage: "Fra"})}</HeaderLabel>}
        <span />
        {to && <HeaderLabel>{formatMessage({id: "universalTo", defaultMessage: "Til"})}</HeaderLabel>}
      </ScheduleHeader>
      {schedule.map((day, index) => {
        const active = day.active;
        return (
          <DayRow key={day.day || index} active={active}>
            <Day
              day={day}
              checked={active}
              onChange={value => setFieldValue(`eventConfig.schedule.${index}.active`, value)}
            />
            {active ? (
              <TimeGroup single={single}>
                {from && (
                  <TimeCell>
                    <TimeInput
                      small
                      type="time"
                      name={`eventConfig.schedule.${index}.fromTime`}
                      fieldValue={setFieldValue}
                      value={day.fromTime}
                    />
                  </TimeCell>
                )}
                {from && to && <RangeDash>–</RangeDash>}
                {to && (
                  <TimeCell>
                    <TimeInput
                      small
                      type="time"
                      name={`eventConfig.schedule.${index}.toTime`}
                      fieldValue={setFieldValue}
                      value={day.toTime}
                    />
                  </TimeCell>
                )}
              </TimeGroup>
            ) : (
              <OffLabel>
                {formatMessage({id: "scheduleDayInactive", defaultMessage: "Varsler ikke denne dagen"})}
              </OffLabel>
            )}
          </DayRow>
        );
      })}
    </ScheduleWrap>
  );
})

export default Schedule;
